import { HbPoItemVariant } from "./hb-po-item-variant";

export class HbPoItemDetails {

    style: string;
    color: string;

    HbpoItemVariantDetails: HbPoItemVariant[]

}